module.exports = __webpack_public_path__ + "static/media/backArrow.c3dd7cdb.svg";